(function () {
  function colorChartUrl(raw, ticket, imageId) {
    var origin = 'https://preview.paintbynumbersking.com';
    if (!/^[A-Za-z0-9-]+$/.test(ticket || '') || !/^[1-9]\d*$/.test(imageId || '') || !Number.isSafeInteger(Number(imageId))) return '';
    var path = '/admin/order-files/' + ticket + '/' + imageId + '/color-chart';
    var expected = origin + path;
    // Cached handoffs predate this field; the staff route does not depend on an upload or customer token.
    if (raw == null || raw === '') return expected;
    if (typeof raw !== 'string') return '';
    try {
      var url = new URL(raw);
      return url.protocol === 'https:' && url.origin === origin && url.pathname === path &&
        !url.username && !url.password && !url.search && !url.hash && url.href === expected ? expected : '';
    } catch (_) { return ''; }
  }

  function getShopifyMoneyFormat(section) {
    if (window.Shopify && Shopify.money_format) return Shopify.money_format;
    return (section && section.getAttribute('data-money-format')) || '${{amount}}';
  }

  function getActiveCurrency(section) {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return (section && section.getAttribute('data-shop-currency')) || 'EUR';
  }

  function parseJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function normalizeCountry(value) {
    var country = String(value || '').trim().toUpperCase();
    return /^[A-Z]{2}$/.test(country) ? country : '';
  }

  function cartUrl(section) {
    return (section && section.getAttribute('data-cart-url')) || '/cart';
  }

  function shopifyRoute(path) {
    var root = '/';
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      root = Shopify.routes.root;
    }
    return String(root || '/').replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function formatMoney(section, cents) {
    var moneyFormat = getShopifyMoneyFormat(section);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    try {
      var lang = document.documentElement.getAttribute('lang') || 'en';
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: getActiveCurrency(section)
      }).format(Number(cents || 0) / 100);
    } catch (e) {
      return '€' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function setActiveTiles(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-option-tile]').forEach(function (tile) {
      var input = tile.querySelector('input');
      tile.classList.toggle('is-active', !!(input && input.checked));
    });
  }

  function parseRecommendedSizeParts(value) {
    var raw = String(value || '').trim();
    if (!raw) return { inch: '', cm: '' };

    var inchMatch = raw.match(/(\d+\s*(?:x|×)\s*\d+\s*(?:in|inch|inches)|\d+"\s*x\s*\d+")/i);
    var cmMatch = raw.match(/(\d+\s*(?:x|×)\s*\d+\s*cm)/i);
    var compactCmMatch = raw.match(/\((\d+\s*(?:x|×)\s*\d+\s*cm)\)/i);

    return {
      inch: inchMatch ? inchMatch[1].replace(/\s+/g, ' ').trim() : '',
      cm: compactCmMatch ? compactCmMatch[1].replace(/\s+/g, ' ').trim() : (cmMatch ? cmMatch[1].replace(/\s+/g, ' ').trim() : '')
    };
  }

  function optionValues(variants, optionIndex) {
    var values = [];
    (variants || []).forEach(function (variant) {
      var value = variant && variant.options ? String(variant.options[optionIndex] || '') : '';
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function normalizeSizeKey(value) {
    var matches = String(value || '').toLowerCase().match(/\d+\s*(?:x|×)\s*\d+/g) || [];
    if (!matches.length) return '';
    var parts = matches[matches.length - 1].match(/(\d+)\s*(?:x|×)\s*(\d+)/);
    return parts ? (parts[1] + 'x' + parts[2]) : '';
  }

  function resolveSizeOption(variants, sizeKey, sizeLabel) {
    var values = optionValues(variants, 0);
    var targetKey = normalizeSizeKey(sizeKey) || normalizeSizeKey(sizeLabel);
    if (targetKey) {
      var sizeMatch = values.find(function (value) {
        return normalizeSizeKey(value) === targetKey;
      });
      if (sizeMatch) return sizeMatch;
    }
    return values.indexOf(sizeLabel) !== -1 ? sizeLabel : (sizeLabel || sizeKey || values[0] || '');
  }

  function resolveDetailOption(variants,value) {
    var values=optionValues(variants,2), n=String(value||'').match(/24|36|48/);
    return values.find(function(v){return v===value || (n && String(v).includes(n[0]));}) || (value ? String(value) : values[0] || '');
  }

  function resolveFrameOption(variants, value) {
    var values = optionValues(variants, 1);
    var normalized = String(value || 'No Frame').trim().toLowerCase();
    var match = values.find(function (candidate) {
      return String(candidate).toLowerCase() === normalized;
    });
    if (!match && normalized.indexOf('no frame') !== -1) {
      match = values.find(function (candidate) {
        return String(candidate).toLowerCase().indexOf('no frame') !== -1;
      });
    }
    return match || values[0] || value || 'No Frame';
  }

  function findVariantByOptions(variants, size, detail, frame) {
    return (variants || []).find(function (variant) {
      return variant.options &&
        variant.options[0] === size &&
        variant.options[2] === detail &&
        variant.options[1] === frame;
    }) || null;
  }

  function markRecommendedSizeOption(sizeSelect, recommendedValue) {
    if (!sizeSelect || !recommendedValue) return;
    Array.prototype.forEach.call(sizeSelect.options || [], function (option) {
      var originalLabel = option.getAttribute('data-original-label') || option.textContent || '';
      option.setAttribute('data-original-label', originalLabel);
      option.removeAttribute('data-recommended-size');
      option.textContent = originalLabel;
      if (option.value !== recommendedValue) return;
      option.setAttribute('data-recommended-size', 'true');
      if (!/our advice|recommended/i.test(option.textContent || '')) {
        option.textContent += ' — Recommended for your preview ⭐';
      }
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      normalizeSizeKey: normalizeSizeKey,
      resolveSizeOption: resolveSizeOption,
      resolveDetailOption: resolveDetailOption,
      resolveFrameOption: resolveFrameOption,
      findVariantByOptions: findVariantByOptions
    };
  }
  if (typeof document === 'undefined') return;

  document.querySelectorAll('[data-preview-order-page]').forEach(function (section) {
    var productData = parseJson(section.getAttribute('data-product-json-id'));
    var priceMap = parseJson(section.getAttribute('data-price-map-json-id')) || {};
    if (!productData || !productData.variants || !productData.variants.length) return;

    var params = new URLSearchParams(window.location.search);
    var previewUrl = params.get('preview_url') || '';
    var originalUrl = params.get('original_url') || '';
    var preservedPreviewUrl = params.get('preserved_preview_url') || previewUrl;
    var preservedOriginalUrl = params.get('preserved_original_url') || originalUrl;
    var ticketNumber = params.get('ticket') || '';
    var imageId = params.get('image_id') || '';
    var previewToken = params.get('pbnk_order_key') || params.get('preview_token') || '';
    var namespacedHandoff = !!params.get('pbnk_order_key');
    var selectedImageIds = (params.get('selected_images') || '')
      .split(',')
      .map(function (value) { return String(value || '').trim(); })
      .filter(Boolean);
    var activeImageId = params.get('active_image_id') || imageId || (selectedImageIds[0] || '');
    var photoLabel = params.get('label') || '';
    var previewPageUrl = params.get('preview_page_url') || '';
    var recommendedSize = params.get('size') || '';
    var recommendedSizeLabel = resolveSizeOption(productData.variants, recommendedSize, params.get('size_label') || '');
    var recommendedDetail = resolveDetailOption(productData.variants, params.get('detail_label') || params.get('detail') || '');
    var recommendedFrame = resolveFrameOption(productData.variants, params.get('frame') || 'No Frame');
    var portalOrigin = section.getAttribute('data-portal-origin') || '';
    if (!/^https:\/\/preview\.paintbynumbersking\.com$/i.test(portalOrigin)) return;
    // A copied old Shopify URL may still contain Shopify's reserved preview_token.
    // Send it back to the canonical customer preview before showing market prices.
    if (!namespacedHandoff && params.get('preview_token') && (params.get('selected_images') || params.get('image_id'))) {
      window.location.replace(portalOrigin + '/preview/' + encodeURIComponent(previewToken));
      return;
    }
    var handoffReady = !namespacedHandoff;
    var preserveEnabled = !!(ticketNumber && imageId && portalOrigin);
    var isUS = section.getAttribute('data-is-us') === 'true';

    var mainImage = section.querySelector('[data-preview-main-image]');
    var enlargeButton = section.querySelector('[data-preview-enlarge]');
    var lightbox = section.querySelector('[data-preview-lightbox]');
    var lightboxImage = section.querySelector('[data-preview-lightbox-image]');
    var lightboxCaption = section.querySelector('[data-preview-lightbox-caption]');
    var lightboxClose = section.querySelector('[data-preview-lightbox-close]');
    var stageLabel = section.querySelector('[data-stage-label]');
    var stageThumbButtons = Array.prototype.slice.call(section.querySelectorAll('[data-stage-thumb]'));
    var thumbPreview = section.querySelector('[data-thumb-preview]');
    var thumbOriginal = section.querySelector('[data-thumb-original]');
    var originalInline = section.querySelector('[data-original-inline]');
    var originalInlineImage = section.querySelector('[data-original-inline-image]');
    var ticketValue = section.querySelector('[data-preview-ticket]');
    var photoValue = section.querySelector('[data-preview-photo]');
    var recommendationValue = section.querySelector('[data-preview-recommendation]');
    var statusBox = section.querySelector('[data-order-status]');
    var priceValues = Array.prototype.slice.call(section.querySelectorAll('[data-main-price]'));
    var comparePriceValue = section.querySelector('[data-compare-price]');
    var saveBadgeWrap = section.querySelector('[data-save-badge-wrap]');
    var saveBadge = section.querySelector('[data-save-badge]');
    var addButton = section.querySelector('[data-add-to-cart]');
    var addButtonText = section.querySelector('[data-add-to-cart-text]');
    var addButtonPrice = section.querySelector('[data-add-to-cart-price]');
    var sizeSelect = section.querySelector('[data-size-select]');
    var detailWrap = section.querySelector('[data-detail-options]');
    var frameWrap = section.querySelector('[data-frame-options]');
    var addButtonBaseLabel = (addButton && addButton.getAttribute('data-base-label')) || 'Add to cart';
    var bundleShell = section.querySelector('[data-bundle-shell]');
    var bundleSelector = section.querySelector('[data-bundle-selector]');
    var bundleSummary = section.querySelector('[data-bundle-summary]');
    var bundleStates = [];

    // PBN-only additions. DP remains responsible for base prices, images and cart transport.
    var isDutch = section.getAttribute('data-language') === 'nl';
    var extraCards = Array.from(section.querySelectorAll('[data-extra-card]'));
    var gallery = section.querySelector('[data-gallery]');
    var galleryData = {};
    try { galleryData = JSON.parse(section.querySelector('[data-gallery-json]').textContent) || {}; } catch (_) {}
    var galleryImages = {};
    try { galleryImages = JSON.parse(section.querySelector('[data-gallery-images]').textContent) || {}; } catch (_) {}
    var galleryImageButton = section.querySelector('[data-gallery-image-open]');
    var galleryImage = section.querySelector('[data-gallery-image]');
    var galleryDialog = section.querySelector('[data-gallery-lightbox]');
    var galleryDialogImage = section.querySelector('[data-gallery-lightbox-image]');
    var photoNoteBox = section.querySelector('[data-photo-note]');
    var galleryImageTrigger = null;
    if (galleryImageButton && galleryDialog) {
      galleryImageButton.addEventListener('click', function () {
        if (!galleryImage || !galleryImage.src) return;
        galleryImageTrigger = galleryImageButton;
        galleryDialogImage.src = galleryImage.src;
        galleryDialogImage.alt = galleryImage.alt;
        galleryDialog.showModal();
        galleryDialog.querySelector('[data-gallery-lightbox-close]').focus();
      });
      galleryDialog.querySelector('[data-gallery-lightbox-close]').addEventListener('click', function () { galleryDialog.close(); });
      galleryDialog.addEventListener('click', function (event) { if (event.target === galleryDialog) galleryDialog.close(); });
      galleryDialog.addEventListener('close', function () { if (galleryImageTrigger) galleryImageTrigger.focus(); });
    }
    function discountedExtra(cents) {
      var rate = Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
      if (!Number.isFinite(rate) || rate <= 0) rate = 1;
      return Math.max(0, Number(cents || 0) - Math.round(500 * rate));
    }
    function matchingGallery(entry) {
      var size = normalizeSizeKey(entry.size);
      if (isUS || !['30x40','40x40','40x50','50x60'].includes(size)) return [];
      return (galleryData.variants || []).filter(function (v) {
        return v.available !== false && (v.options || []).some(function (value) { return normalizeSizeKey(value) === size; });
      });
    }
    function chosenGallery(entry) {
      return entry.galleryYes && matchingGallery(entry).find(function (v) { return String(v.id) === entry.galleryId; });
    }
    function syncGallery() {
      if (!gallery) return;
      var entry = currentBundleState();
      if (!entry) return;
      var variants = matchingGallery(entry);
      gallery.hidden = !variants.length;
      if (!variants.length) {
        entry.galleryYes = false;
        entry.galleryId = '';
        gallery.querySelector('[data-gallery-yes]').checked = false;
        gallery.querySelector('[data-gallery-options]').hidden = true;
        return;
      }
      var select = gallery.querySelector('[data-gallery-variant]');
      if (!variants.some(function(v){return String(v.id)===entry.galleryId;})) entry.galleryId='';
      select.replaceChildren(new Option(isDutch?'Kies een kleur':'Select a colour',''));
      variants.forEach(function(v){
        var colour = (v.options || []).filter(function(option){return normalizeSizeKey(option) !== normalizeSizeKey(entry.size);}).join(' / ');
        select.add(new Option(colour || v.title || String(v.id),String(v.id)));
      });
      select.value=entry.galleryId || '';
      gallery.querySelector('[data-gallery-yes]').checked=!!entry.galleryYes;
      gallery.querySelector('[data-gallery-options]').hidden=!entry.galleryYes;
      var v=chosenGallery(entry);
      gallery.querySelector('[data-gallery-price]').textContent=v?formatMoney(section,discountedExtra(v.price)):'';
      gallery.querySelector('[data-gallery-was]').textContent=v?formatMoney(section,v.price):'';
      if (galleryImage && galleryImageButton) {
        var image = (v && galleryImages[String(v.id)]) || galleryImages.default || '';
        galleryImageButton.hidden = !image;
        if (image) galleryImage.src = image;
      }
    }
    function extrasFor(entries) {
      var lines=[];
      extraCards.forEach(function(card){
        if(!card.querySelector('[data-extra-input]').checked || !entries.length)return;
        lines.push({id:Number(card.dataset.id),quantity:card.dataset.mode==='per_photo'?entries.length:1,
          properties:{_pbnk_addon:card.dataset.key},displayPrice:discountedExtra(card.dataset.price)});
      });
      entries.forEach(function(entry){var v=chosenGallery(entry);if(v)lines.push({id:Number(v.id),quantity:1,
        properties:{_pbnk_addon:'gallery_frame',_image_id:entry.imageId},displayPrice:discountedExtra(v.price)});});
      return lines;
    }
    function renderRecommendation(entry) {
      if(!recommendationValue || !entry)return;
      var advice=entry.recommendation,parts=parseRecommendedSizeParts(advice.size),labels=[];
      if(isUS){if(parts.inch)labels.push(parts.inch);if(parts.cm)labels.push(parts.cm);}
      else{if(parts.cm)labels.push(parts.cm);if(parts.inch)labels.push(parts.inch);}
      if(!labels.length&&advice.size)labels.push(advice.size);
      if(advice.detail)labels.push(advice.detail);
      if(advice.frame)labels.push(advice.frame);
      recommendationValue.textContent=labels.join(' / ') || '—';
    }
    function syncPbnChoices() {
      var entry=currentBundleState();if(!entry)return;
      renderRecommendation(entry);
      var advice=entry.recommendation.size || '';
      var parts=parseRecommendedSizeParts(advice);
      if(parts.cm&&parts.inch)advice=isUS?parts.inch+' ('+parts.cm+')':parts.cm+' ('+parts.inch+')';
      var label=section.querySelector('[data-size-recommendation]');
      label.textContent=(isDutch?'Aanbevolen formaat: ':'Recommended size: ')+advice;
      label.hidden=!advice;
      section.querySelector('[data-size-choice]').hidden=!advice;
      section.querySelector('[data-size-picker]').hidden=!!advice&&!entry.changeSize;
      section.querySelector('[data-size-warning]').hidden=!advice || normalizeSizeKey(current.size)===normalizeSizeKey(entry.recommendation.size);
      section.querySelector('[data-size-choice] [value="recommended"]').checked=!entry.changeSize;
      section.querySelector('[data-size-choice] [value="change"]').checked=!!entry.changeSize;
      syncGallery();
    }
    extraCards.forEach(function(card){
      card.querySelector('[data-extra-price]').textContent=formatMoney(section,discountedExtra(card.dataset.price));
      card.querySelector('[data-extra-was]').textContent=formatMoney(section,Number(card.dataset.price));
      card.addEventListener('change',refreshAddButton);
    });
    if(gallery)gallery.addEventListener('change',function(){
      var entry=currentBundleState();if(!entry)return;
      entry.galleryYes=gallery.querySelector('[data-gallery-yes]').checked;
      entry.galleryId=gallery.querySelector('[data-gallery-variant]').value;
      syncGallery();refreshAddButton();
    });
    section.querySelector('[data-size-choice]').addEventListener('change',function(event){
      var entry=currentBundleState();if(!entry)return;
      entry.changeSize=event.target.value==='change';
      if(!entry.changeSize){current.size=entry.recommendation.size;sizeSelect.value=current.size;}
      syncVariantState();
    });

    if (previewUrl && mainImage) mainImage.src = previewUrl;
    if (previewUrl && thumbPreview) thumbPreview.src = previewUrl;
    if (originalUrl && thumbOriginal) thumbOriginal.src = originalUrl;
    if (originalUrl && originalInline && originalInlineImage) {
      originalInline.hidden = false;
      originalInlineImage.src = originalUrl;
    }

    function createBundleState(item) {
      var recommendation=Object.freeze({
        size: resolveSizeOption(productData.variants,item.size || recommendedSize,item.size_label || recommendedSizeLabel),
        detail: resolveDetailOption(productData.variants,item.detail_label || item.detail || recommendedDetail),
        frame: resolveFrameOption(productData.variants,item.frame || 'No Frame')
      });
      return {
        imageId: String(item.image_id || imageId || ''),
        colorChartUrl: colorChartUrl(item.color_chart_url, ticketNumber, String(item.image_id || imageId || '')),
        label: item.label || photoLabel || 'Photo',
        note: String(item.photo_note || ''),
        previewUrl: item.preview_url || previewUrl || '',
        originalUrl: item.original_url || originalUrl || '',
        preservedPreviewUrl: item.preserved_preview_url || preservedPreviewUrl || item.preview_url || previewUrl || '',
        preservedOriginalUrl: item.preserved_original_url || preservedOriginalUrl || item.original_url || originalUrl || '',
        size: resolveSizeOption(
          productData.variants,
          item.size || recommendedSize,
          item.size_label || recommendedSizeLabel || current.size
        ),
        sizeKey: item.size || recommendedSize || '',
        recommendation: recommendation,
        changeSize:false, galleryYes:false, galleryId:'',
        detail: resolveDetailOption(productData.variants, item.selected_detail || item.detail_label || item.detail || recommendedDetail || current.detail),
        frame: resolveFrameOption(productData.variants, item.selected_frame || item.selected_frame || item.frame || recommendedFrame || current.frame),
        selected: true
      };
    }

    function currentBundleState() {
      return bundleStates.find(function (entry) {
        return entry.imageId === String(activeImageId || imageId || '');
      }) || null;
    }

    function activeOrderEntry() {
      return currentBundleState() || {
        imageId: String(imageId || ''),
        colorChartUrl: colorChartUrl(params.get('color_chart_url'), ticketNumber, imageId),
        label: photoLabel || 'Photo',
        previewUrl: previewUrl || '',
        originalUrl: originalUrl || '',
        preservedPreviewUrl: preservedPreviewUrl || previewUrl || '',
        preservedOriginalUrl: preservedOriginalUrl || originalUrl || '',
        size: current.size,
        detail: current.detail,
        frame: current.frame
      };
    }

    function variantPriceForEntry(entry) {
      var variant = variantByOptions(entry.size, entry.detail, entry.frame);
      if (!variant) return 0;
      var priceEntry = priceMap[String(variant.id)] || null;
      return priceEntry ? Number(priceEntry.price || 0) : Number(variant.price || 0);
    }

    function refreshAddButton() {
      if (!addButton) return;
      var selectedEntries = bundleStates.length > 1
        ? bundleStates.filter(function (entry) { return entry.selected; })
        : [activeOrderEntry()];
      var total = selectedEntries.reduce(function (sum, entry) {
        return sum + variantPriceForEntry(entry);
      }, 0);
      var count = selectedEntries.length;
      var extras=extrasFor(selectedEntries),extrasTotal=extras.reduce(function(sum,e){return sum+e.displayPrice*e.quantity;},0);
      var totals=section.querySelector('[data-order-totals]');totals.replaceChildren();
      [[isDutch?'Schilderij(en)':'Painting(s)',total],[isDutch?'Extra’s':'Selected extras',extrasTotal],['Total',total+extrasTotal]].forEach(function(row){
        var line=document.createElement('div');line.className='pbn-summary-row';var label=document.createElement('strong'),value=document.createElement('span');
        label.textContent=row[0];value.textContent=formatMoney(section,row[1]);line.append(label,value);totals.append(line);
      });
      total+=extrasTotal;
      var blocked=!handoffReady||!count||selectedEntries.some(function(e){var v=variantByOptions(e.size,e.detail,e.frame);return !v||v.available===false||(e.galleryYes&&matchingGallery(e).length&&!chosenGallery(e));});

      if (addButtonText) {
        if (!count) {
          addButtonText.textContent = 'Select at least 1 photo';
        } else {
          addButtonText.textContent = count > 1 ? ('Add ' + count + ' photos to cart') : addButtonBaseLabel;
        }
      }
      if (addButtonPrice) {
        addButtonPrice.textContent = formatMoney(section, total);
      }
      addButton.disabled = blocked;
      addButton.classList.toggle('is-disabled', blocked);
      addButton.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    }

    function renderBundleSummary() {
      if (!bundleShell || !bundleSummary || bundleStates.length <= 1) return;
      var selectedItems = bundleStates.filter(function (entry) { return entry.selected; });
      if (!selectedItems.length) {
        bundleSummary.hidden = true;
        bundleSummary.innerHTML = '';
        return;
      }
      bundleSummary.hidden = false;
      bundleSummary.innerHTML = '';
      selectedItems.forEach(function (entry) {
        var row = document.createElement('div');
        row.className = 'pbn-bundle-summary-row';
        var name=document.createElement('span'),options=document.createElement('span');name.textContent=entry.label;options.textContent=[entry.size,entry.detail,entry.frame].filter(Boolean).join(' • ');row.append(name,options);
        bundleSummary.appendChild(row);
      });
    }

    function renderBundleSelector() {
      if (!bundleShell || !bundleSelector || bundleStates.length <= 1) return;
      bundleShell.classList.add('is-active');
      bundleSelector.innerHTML = '';
      bundleStates.forEach(function (entry) {
        var card = document.createElement('div');
        card.className = 'pbn-bundle-card' + (entry.imageId === String(activeImageId) ? ' is-active' : '') + (entry.selected ? '' : ' is-inactive');

        var previewButton = document.createElement('button');
        previewButton.type = 'button';
        previewButton.className = 'pbn-bundle-card-main';
        previewButton.setAttribute('aria-pressed', entry.imageId === String(activeImageId) ? 'true' : 'false');
        previewButton.addEventListener('click', function () {
          activeImageId = entry.imageId;
          applyBundleState(entry);
        });

        var thumbWrap = document.createElement('span');
        thumbWrap.className = 'pbn-bundle-thumb';
        var thumbImage = document.createElement('img');
        thumbImage.src = entry.originalUrl || entry.previewUrl || '';
        thumbImage.alt = entry.label;
        thumbWrap.appendChild(thumbImage);

        var meta = document.createElement('span');
        meta.className = 'pbn-bundle-meta';
        var label = document.createElement('span');
        label.className = 'pbn-bundle-label';
        label.textContent = entry.label;
        var options = document.createElement('span');
        options.className = 'pbn-bundle-options';
        options.textContent = [entry.size, entry.detail, entry.frame].filter(Boolean).join(' • ');
        meta.appendChild(label);
        meta.appendChild(options);

        previewButton.appendChild(thumbWrap);
        previewButton.appendChild(meta);

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'pbn-bundle-toggle';
        toggle.textContent = entry.selected ? 'Remove' : 'Add back';
        toggle.addEventListener('click', function (event) {
          event.stopPropagation();
          entry.selected = !entry.selected;
          if (entry.selected) {
            activeImageId = entry.imageId;
          } else if (entry.imageId === String(activeImageId)) {
            var nextSelected = bundleStates.find(function (candidate) { return candidate.selected; });
            if (nextSelected) {
              activeImageId = nextSelected.imageId;
            }
          }

          var activeEntry = bundleStates.find(function (candidate) {
            return candidate.imageId === String(activeImageId);
          }) || entry;
          applyBundleState(activeEntry);
        });

        card.appendChild(previewButton);
        card.appendChild(toggle);
        bundleSelector.appendChild(card);
      });
      renderBundleSummary();
    }

    function syncOptionInputs(scope, name, value) {
      if (!scope) return;
      scope.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        input.checked = input.value === value;
      });
      setActiveTiles(scope);
    }

    function applyBundleState(entry) {
      if (!entry) return;
      imageId = entry.imageId;
      photoLabel = entry.label;
      if (photoNoteBox) { photoNoteBox.textContent = entry.note || ''; photoNoteBox.hidden = !entry.note; }
      previewUrl = entry.previewUrl;
      originalUrl = entry.originalUrl;
      preservedPreviewUrl = entry.preservedPreviewUrl;
      preservedOriginalUrl = entry.preservedOriginalUrl;
      current.size = entry.size || current.size;
      current.detail = entry.detail || current.detail;
      current.frame = entry.frame || current.frame;

      if (mainImage && previewUrl) mainImage.src = previewUrl;
      if (thumbPreview && previewUrl) thumbPreview.src = previewUrl;
      if (thumbOriginal && originalUrl) thumbOriginal.src = originalUrl;
      if (originalInline && originalInlineImage) {
        originalInline.hidden = !originalUrl;
        if (originalUrl) originalInlineImage.src = originalUrl;
      }
      if (photoValue) photoValue.textContent = photoLabel || '—';
      if (ticketValue) ticketValue.textContent = ticketNumber || '—';
      if (sizeSelect && current.size) {
        sizeSelect.value = current.size;
        markRecommendedSizeOption(sizeSelect, currentBundleState().recommendation.size);
      }
      syncOptionInputs(detailWrap, 'preview-order-detail-' + section.getAttribute('data-section-id'), current.detail);
      syncOptionInputs(frameWrap, 'preview-order-frame-' + section.getAttribute('data-section-id'), current.frame);
      setStage('preview');
      syncVariantState();
      renderBundleSelector();
    }

    if (ticketValue) ticketValue.textContent = ticketNumber || '—';
    if (photoValue) photoValue.textContent = photoLabel || '—';

    var previousBodyOverflow = '';

    function openImageLightbox() {
      if (!mainImage || !lightbox || !lightboxImage) return;
      var imageUrl = mainImage.currentSrc || mainImage.src || '';
      if (!imageUrl) return;

      lightboxImage.src = imageUrl;
      lightboxImage.alt = mainImage.alt || 'Preview image';
      if (lightboxCaption) {
        lightboxCaption.textContent = mainImage.alt || '';
      }
      previousBodyOverflow = document.body.style.overflow || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (lightboxClose) {
        lightboxClose.focus();
      }
    }

    function closeImageLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      if (lightboxImage) {
        lightboxImage.src = '';
      }
      document.body.style.overflow = previousBodyOverflow;
    }

    if (enlargeButton) {
      enlargeButton.addEventListener('click', openImageLightbox);
    }
    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeImageLightbox);
    }
    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          closeImageLightbox();
        }
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeImageLightbox();
      }
    });

    function setStage(mode) {
      if (!mainImage) return;
      var isOriginal = mode === 'original' && originalUrl;
      var imageUrl = isOriginal ? originalUrl : previewUrl;
      var activeButton = stageThumbButtons.find(function (button) {
        return button.getAttribute('data-stage-thumb') === (isOriginal ? 'original' : 'preview');
      });
      var labelNode = activeButton ? activeButton.querySelector('.pbn-preview-thumb-label') : null;
      var label = labelNode ? labelNode.textContent : (isOriginal ? 'Original photo' : 'Preview');
      mainImage.src = imageUrl || previewUrl || originalUrl || mainImage.src;
      mainImage.alt = label;
      if (stageLabel) stageLabel.textContent = label;
      stageThumbButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-stage-thumb') === (isOriginal ? 'original' : 'preview'));
      });
    }

    stageThumbButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setStage(button.getAttribute('data-stage-thumb'));
      });
    });
    setStage('preview');

    var current = {
      size: recommendedSizeLabel,
      detail: recommendedDetail,
      frame: recommendedFrame
    };

    bundleStates = [createBundleState({
      image_id: imageId,
      color_chart_url: params.get('color_chart_url'),
      label: photoLabel,
      preview_url: previewUrl,
      original_url: originalUrl,
      preserved_preview_url: preservedPreviewUrl,
      preserved_original_url: preservedOriginalUrl,
      size: recommendedSize,
      size_label: recommendedSizeLabel,
      detail: recommendedDetail,
      frame: recommendedFrame,
      selected_size: recommendedSizeLabel,
      selected_detail: recommendedDetail,
      selected_frame: recommendedFrame
    })];

    if (sizeSelect && current.size && currentBundleState()) {
      sizeSelect.value = current.size;
      markRecommendedSizeOption(sizeSelect, currentBundleState().recommendation.size);
    }

    function variantByOptions(size, detail, frame) {
      return findVariantByOptions(productData.variants, size, detail, frame);
    }

    function syncVariantState() {
      syncPbnChoices();
      var variant = variantByOptions(current.size, current.detail, current.frame);
      if (!variant) { var invalidEntry=currentBundleState();if(invalidEntry){invalidEntry.size=current.size;invalidEntry.detail=current.detail;invalidEntry.frame=current.frame;}refreshAddButton();return null; }

      current.size = variant.options[0];
      current.detail = variant.options[2];
      current.frame = variant.options[1];

      if (sizeSelect) sizeSelect.value = current.size;
      syncOptionInputs(detailWrap,'preview-order-detail-'+section.getAttribute('data-section-id'),current.detail);
      syncOptionInputs(frameWrap,'preview-order-frame-'+section.getAttribute('data-section-id'),current.frame);

      var priceEntry = priceMap[String(variant.id)] || null;
      var variantPrice = priceEntry ? Number(priceEntry.price || 0) : Number(variant.price || 0);
      var variantCompare = priceEntry ? Number(priceEntry.compare_at_price || 0) : Number(variant.compare_at_price || 0);
      var formattedMainPrice = formatMoney(section, variantPrice);

      priceValues.forEach(function (priceValue) {
        priceValue.setAttribute('data-cents', String(variantPrice));
        priceValue.textContent = formattedMainPrice;
      });

      if (comparePriceValue) {
        if (variantCompare > variantPrice) {
          comparePriceValue.hidden = false;
          comparePriceValue.setAttribute('data-cents', String(variantCompare));
          comparePriceValue.textContent = formatMoney(section, variantCompare);
        } else {
          comparePriceValue.hidden = true;
          comparePriceValue.textContent = '';
        }
      }

      if (saveBadge) {
        if (variantCompare > variantPrice) {
          var savePercent = Math.round(((variantCompare - variantPrice) / variantCompare) * 100);
          if (saveBadgeWrap) saveBadgeWrap.hidden = false;
          saveBadge.hidden = false;
          saveBadge.textContent = 'Save ' + String(savePercent) + '% Today';
        } else {
          if (saveBadgeWrap) saveBadgeWrap.hidden = true;
          saveBadge.hidden = true;
          saveBadge.textContent = '';
        }
      }

      if (addButton) refreshAddButton();

      var activeEntry = currentBundleState();
      if (activeEntry) {
        activeEntry.size = current.size;
        activeEntry.detail = current.detail;
        activeEntry.frame = current.frame;
        activeEntry.variantId = String(variant.id || '');
      }
      syncPbnChoices();
      renderBundleSummary();
      refreshAddButton();

      return variant;
    }

    function wireOptionGroup(scope, key) {
      if (!scope) return;
      scope.addEventListener('change', function (event) {
        var input = event.target.closest('input[type="radio"]');
        if (!input) return;
        current[key] = input.value;
        setActiveTiles(scope);
        syncVariantState();
      });
      setActiveTiles(scope);
    }

    wireOptionGroup(detailWrap, 'detail');
    wireOptionGroup(frameWrap, 'frame');

    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        current.size = sizeSelect.value;
        syncVariantState();
      });
    }

    function setStatus(message, tone) {
      if (!statusBox) return;
      statusBox.textContent = message || '';
      statusBox.classList.remove('is-error', 'is-success');
      if (tone === 'error') statusBox.classList.add('is-error');
      if (tone === 'success') statusBox.classList.add('is-success');
    }

    async function preserveSelection(variant) {
      if (!preserveEnabled || !variant) return;
      var body = new URLSearchParams();
      body.set('variant_id', String(variant.id));
      body.set('size', current.size);
      body.set('detail', current.detail);
      body.set('frame', current.frame);
      if (previewToken) body.set('preview_token', previewToken);
      await fetch(
        portalOrigin.replace(/\/$/, '') +
          '/api/ticket/' + encodeURIComponent(ticketNumber) +
          '/images/' + encodeURIComponent(imageId) +
          '/preserve-converted',
        { method: 'POST', body: body }
      );
    }

    async function loadBundleSelection() {
      if (!previewToken || !selectedImageIds.length || !portalOrigin) {
        if (namespacedHandoff) setStatus('Your preview link is incomplete. Please return to your customer preview.', 'error');
        return;
      }
      try {
        if (!/^[A-Za-z0-9]{8,128}$/.test(previewToken) || selectedImageIds.length > 50 || selectedImageIds.some(function (id) { return !/^\d+$/.test(id); })) throw new Error('invalid_handoff');
        var response = await fetch(
          portalOrigin.replace(/\/$/, '') +
            '/api/preview/' + encodeURIComponent(previewToken) +
            '/shopify-bundle?image_ids=' + encodeURIComponent(selectedImageIds.join(','))
        );
        if (!response.ok) throw new Error('preview_unavailable');
        var payload = await response.json();
        if (!payload || !payload.success || !/^[A-Za-z0-9-]+$/.test(payload.ticket_number || '') || !Array.isArray(payload.items) || payload.items.length !== selectedImageIds.length) throw new Error('invalid_selection');
        if (params.get('ticket') && params.get('ticket') !== payload.ticket_number) throw new Error('invalid_selection');
        var items = selectedImageIds.map(function (id) {
          var matching = payload.items.filter(function (item) { return String(item.image_id) === id && item.product_type === 'pbn'; });
          if (matching.length !== 1) throw new Error('invalid_selection');
          var item = matching[0];
          [item.preview_url, item.original_url].forEach(function (raw) {
            var url = new URL(String(raw || ''));
            if (url.protocol !== 'https:' || url.origin !== portalOrigin || url.username || url.password) throw new Error('invalid_image');
          });
          return item;
        });
        ticketNumber = payload.ticket_number;
        previewPageUrl = portalOrigin + '/preview/' + encodeURIComponent(previewToken);
        bundleStates = items.map(function (item) {
          return createBundleState(item);
        });
        handoffReady = true;
        preserveEnabled = true;
        var matchingActive = bundleStates.find(function (entry) {
          return entry.imageId === String(activeImageId || '');
        }) || bundleStates[0];
        if (matchingActive) {
          activeImageId = matchingActive.imageId;
          applyBundleState(matchingActive);
        } else {
          renderBundleSelector();
        }
      } catch (error) {
        handoffReady = false;
        refreshAddButton();
        setStatus('We could not load this approved preview. Please return to your customer preview and try again.', 'error');
      }
    }

    async function addMainProducts(items) {
      var res = await fetch(shopifyRoute('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });

      if (!res.ok) throw new Error('main_add_failed');
      return await res.json();
    }

    if (addButton) {
      addButton.addEventListener('click', async function () {
        if (addButton.disabled || !handoffReady) {
          return;
        }
        var variant = syncVariantState();
        if (!variant) {
          setStatus('No matching variant was found for this combination.', 'error');
          return;
        }

        addButton.disabled = true;
        setStatus('Adding your order to cart...', '');

        try {
          var selectedEntries = bundleStates.length > 1
            ? bundleStates.filter(function (entry) { return entry.selected; })
            : [activeOrderEntry()];
          if (!selectedEntries.length) {
            setStatus('Please select at least one photo to continue.', 'error');
            addButton.disabled = false;
            return;
          }
          var items = selectedEntries.map(function (entry) {
            var entryVariant = variantByOptions(entry.size, entry.detail, entry.frame) || variant;
            return {
              id: Number(entryVariant.id),
              quantity: 1,
              properties: {
                '_pbnk_product_type': 'pbn',
                '_ticket_number': ticketNumber,
                '_image_id': entry.imageId,
                ...(entry.previewUrl && entry.originalUrl && entry.colorChartUrl ? { '_color_chart_url': entry.colorChartUrl } : {}),
                '_photo_label': entry.label,
                '_photo_note': entry.note || '',
                '_original_photo_url': entry.originalUrl,
                '_preview_photo_url': entry.previewUrl,
                '_legacy_original_photo_url': entry.originalUrl,
                '_legacy_preview_photo_url': entry.previewUrl,
                '_preserved_original_photo_url': entry.preservedOriginalUrl,
                '_preserved_preview_photo_url': entry.preservedPreviewUrl,
                '_chosen_size': entry.size,
                '_chosen_detail': entry.detail,
                '_chosen_frame': entry.frame,
                '_customer_country': normalizeCountry(section.getAttribute('data-current-country')),
                '_variant_id': String(entryVariant.id)
              }
            };
          });
          var extras=extrasFor(selectedEntries).map(function(e){return {id:e.id,quantity:e.quantity,properties:e.properties};});
          await addMainProducts(items.concat(extras));
          try {
            for (var index = 0; index < selectedEntries.length; index += 1) {
              var preserveVariant = variantByOptions(selectedEntries[index].size, selectedEntries[index].detail, selectedEntries[index].frame) || variant;
              imageId = selectedEntries[index].imageId;
              current.size = selectedEntries[index].size;
              current.detail = selectedEntries[index].detail;
              current.frame = selectedEntries[index].frame;
              await preserveSelection(preserveVariant);
            }
          } catch (err) {}
          setStatus('Added to cart. Redirecting...', 'success');
          window.location.href = cartUrl(section);
        } catch (error) {
          setStatus('We could not add this order to the cart. Please try again.', 'error');
          addButton.disabled = false;
        }
      });
    }

    syncVariantState();
    loadBundleSelection();
  });
})();
